/**
 * @generated SignedSource<<583af0bf5d1397e9bb81877c0829a09c>>
 * @relayHash ed1c7ead1865251e45173593feb0b728
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b96b68ccc999039ea351e31941246e5bb0c0400a30e73f61b5c8a6ce57245ae1

import type { ConcreteRequest } from 'relay-runtime';
export type useConnectorStatesQuery$variables = {
  first?: number | null;
  orgId: string;
  resourceId: string;
};
export type useConnectorStatesQuery$data = {
  readonly admin_getAllDataSources: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly datasources: ReadonlyArray<{
          readonly enabled: boolean;
        }> | null;
        readonly type: string;
      } | null;
    }> | null;
  } | null;
};
export type useConnectorStatesQuery = {
  response: useConnectorStatesQuery$data;
  variables: useConnectorStatesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orgId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resourceId"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "orgId",
        "variableName": "orgId"
      },
      {
        "kind": "Variable",
        "name": "resourceId",
        "variableName": "resourceId"
      }
    ],
    "concreteType": "AdminConnectorConnection",
    "kind": "LinkedField",
    "name": "admin_getAllDataSources",
    "plural": false,
    "selections": [
      {
        "concreteType": "AdminConnectorEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "AdminConnector",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "type"
              },
              {
                "concreteType": "AdminDataSource",
                "kind": "LinkedField",
                "name": "datasources",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "enabled"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useConnectorStatesQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useConnectorStatesQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "ed1c7ead1865251e45173593feb0b728",
    "id": "b96b68ccc999039ea351e31941246e5bb0c0400a30e73f61b5c8a6ce57245ae1",
    "metadata": {},
    "name": "useConnectorStatesQuery",
    "operationKind": "query",
    "text": "query useConnectorStatesQuery($orgId:ID!,$resourceId:ID!,$first:Int){admin_getAllDataSources(orgId:$orgId,resourceId:$resourceId,first:$first){edges{node{type,datasources{enabled}}}}}"
  }
};
})();

(node as any).hash = "c1e906a9d592c8090d7d5864937f0dbe";

export default node;
